import React from "react";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";

class DeletePackageDialog extends React.PureComponent {
  render() {
    const { t } = this.props;
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.props.onHide}
        size="xs"
        title={t("SingleSoftwareCatalog.PackagesTab.DeleteModal.Title")}
        dialogApiError={this.props.dialogApiError}
        rightButtonCallback={this.props.onSubmit}
        rightButtonText={t("SingleSoftwareCatalog.PackagesTab.DeleteModal.Confirm")}
        rightButtonVariant="red"
        leftButtonCallback={this.props.onHide}
        leftButtonText={t("DialogCancel")}
        leftButtonVariant="black"
        body={(<p>
          {t("SingleSoftwareCatalog.PackagesTab.DeleteModal.Text", {
            packageName: this.props.name
          })}
        </p>)}
      />
    );
  }
}

export default withTranslation()(DeletePackageDialog);
